module.exports = __webpack_public_path__ + "static/media/DSC04568.82a8cb4c.jpg";